import { Avatar, Chip } from '@mui/material';
import { useRef, useState, useEffect, useContext } from 'react';
import { generateId } from '../../utils/functions';
import { Context } from '../../AuthContext';

const AuthorSearchField = ({
  authors,
  setAuthors,
  vertical_id,
  handleDelete,
  field,
  formData,
  setFormData,
}) => {
  const { user } = useContext(Context);
  const [searchResult, setSearchResult] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setSearchResult([]); // Close dropdown when clicking outside the input
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div
        className="input-style"
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          border: isFocused ? '2px solid #2C68C4' : '1px solid #e2e8f0', // Change border color when focused
          borderRadius: '4px',
        }}
        onClick={() => inputRef.current?.focus()}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'left',
            flexWrap: 'wrap',
            listStyle: 'none',
            p: 0,
            m: 0,
          }}
        >
          {authors.map((data, index) => {
            let icon;
            return (
              <div key={index} style={{ marginRight: 10 }}>
                <Chip
                  icon={icon}
                  label={data.name}
                  onDelete={() => handleDelete(data)}
                  variant="outlined"
                  color={data.db ? 'primary' : 'warning'}
                  size="medium"
                  style={{ marginTop: '5px', marginBottom: '5px' }}
                />
              </div>
            );
          })}

          <input
            ref={inputRef}
            type="text"
            id={field.name}
            name={field.name}
            style={{
              flex: 1,
              minWidth: '120px',
              border: 'none',
              outline: 'none',
              padding: '4px',
            }}
            placeholder={field.placeholder || ''}
            pattern={field.pattern ? field.pattern : undefined}
            title={field.title ? field.title : undefined}
            value={formData[field.name] || ''}
            disabled={field.disabled || false}
            autoComplete="off"
            onChange={async (event) => {
              try {
                const searchQuery = event.target.value;
                const fieldName = event.target.name;
                setFormData({ ...formData, [fieldName]: searchQuery });

                // Call API
                if (searchQuery.length > 2 && user) {
                  const token = await user.getIdToken();
                  const response = await fetch(
                    `${process.env.REACT_APP_FLASK_WEBSERVER}get_author_search?vertical_id=${vertical_id}&query=${searchQuery}`,
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  );
                  if (response.status === 403) {
                    setSearchResult([]);
                    return;
                  }
                  const result = await response.json();
                  setSearchResult(result);
                } else {
                  setSearchResult([]);
                }
              } catch (error) {
                console.log('Something went wrongs', error);
              }
            }}
            onFocus={() => setIsFocused(true)} // Set focus state
            onBlur={(event) => {
              event.preventDefault();
              setIsFocused(false);
              const { name, value } = event.target;
              if (value && searchResult.length === 0) {
                setFormData({
                  ...formData,
                  [name]: '',
                });
                setAuthors([...authors, { authorId: generateId(), name: value, db: false }]);
                setSearchResult([]);
              }
            }}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ',' || event.key === 'Tab') {
                event.preventDefault();
                const { name, value } = event.target;
                if (value) {
                  setFormData({
                    ...formData,
                    [name]: '',
                  });
                  setAuthors([...authors, { authorId: generateId(), name: value, db: false }]);
                }
              }
              if (event.key === 'Backspace') {
                console.log('Backspace');
                if (authors.length > 0 && event.target.value.length === 0) {
                  event.preventDefault();
                  // setAuthors(authors.slice(0, -1));
                  console.log('Sending delete signal: ', authors.at(-1));

                  console.log('Call func');

                  handleDelete(authors.at(-1));

                  console.log('Func ended');
                }
              }
            }}
          />
        </div>
      </div>

      {searchResult.length > 0 && (
        <div
          style={{
            border: '1px solid #EAEAEA',
            position: 'absolute',
            backgroundColor: '#FAFAFA',
            width: '65%',
            zIndex: 1000,
            borderRadius: '8px',
          }}
        >
          {searchResult.map((item, index) => (
            <li
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '0 5px 0 5px',
                cursor: 'pointer',
                borderBottom: index !== searchResult.length - 1 ? '1px solid #EAEAEA' : 'none',
              }}
              className="autocomplete-item"
              onMouseDown={() => {
                setFormData({
                  ...formData,
                  [field.name]: '',
                });
                setAuthors([...authors, { authorId: item.authorId, name: item.name, db: true }]);
                setSearchResult([]);
              }}
            >
              <div>
                <Avatar alt={item.name} src="/broken-image.jpg">
                  {item.name.split('')[0]}
                </Avatar>
              </div>
              <p style={{ marginLeft: 10 }}>{item.name}</p>
            </li>
          ))}
        </div>
      )}
    </>
  );
};

export default AuthorSearchField;
